import { nonLatinLanguages } from "../services/speech/static-lang-list";

export function isScriptLanguage(langCode: string) {
  return nonLatinLanguages.includes(langCode);
}
